import ReactLoadingSkeleton, { SkeletonProps } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

type Props = SkeletonProps;

export function Skeleton({ ...rest }: Props) {
	return <ReactLoadingSkeleton style={{ zIndex: 89 }} {...rest} />;
}
